import React from "react";
import ReactCollapsingTable from 'react-collapsing-table'


const CustomTable = ({ rows, columns, rowSize, showPagination, tableCallbacks, currentPage, paginationEventListener, totalPages }) => {
  return (
    <>
      <ReactCollapsingTable rows={rows} rowSize={ rowSize } callbacks={tableCallbacks} columns={columns} 
        showPagination={showPagination} paginationEventListener={paginationEventListener} 
        totalPages={totalPages} currentPage={currentPage}/>
    </>
  )
};

export default CustomTable;
